module.exports = __webpack_public_path__ + "static/media/19.45e4ff75.JPG";